import React, { useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Radio,
  Paper,
  Tooltip,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import DoBarChart from "../DoBarChart";
import ComingSoon from "../../SKU-STO-Chart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import TableWithChart from "../LT_Capacity_Breach";
import dayjs from "dayjs";
import AccuracyChart from "../AccuracyChart";
import { forEach } from "lodash";
import AutoCompleteSearchField from "../AutoCompleteSearchField";
import { setModuleTabIndex } from "../../../../store/Actions";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
 
function TabPanel(props) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}
 
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
 
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
 
const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
    // marginRight: "100px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
    alignSelf: "center",
  },
}));
 
// const dummyData = [{
//     "Network": "Ambient",
//     "Cost_Per_Case": 2.2350040995615656
// },
// {
//     "Network": "Tempcontrolled",
//     "Cost_Per_Case": 2.0836020654393117
// },
// {
//     "Network": "Frozen",
//     "Cost_Per_Case": 1.5215655528540184
// },
// {
//     "Network": "Chilled",
//     "Cost_Per_Case": 1.2189636888844442
// }]
 
const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];
 
const GraphViewCapacityPlanning = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  dateRangeCP,
  applyFilter,
  role,
  DateRangeFilterCPActions,
  setCurrentTabCP,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const allData = useSelector((state) => state);
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  const chartData = [];
  // const [yAxisTitle, setYAxisTitle] = useState('');
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const [duration, setDuration] = useState(4);
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  const [graphDataLT, setGraphDataLT] = useState([]);
  const [expansionGraphDataLT, setExpansionGraphDataLT] = useState([]);
  const [graphDataST, setGraphDataST] = useState([]);
  const [expansionGraphDataST, setExpansionGraphDataST] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList?.filter(
    (item) => item.index === tabValue
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [entityAndThreshold, setEntityAndThreshold] = useState([]);
  const [updateThreshold, setUpdateThreshold] = useState(false);
  const [entityNameLT, setEntityNameLT] = useState("");
  const [entityNameST, setEntityNameST] = useState("");
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [metricName, setMetricName] = useState("Network");
  const [metricOptions, setMetricOptions] = useState(
    activeTab === "Bias" ? [...networkOptions] : []
  );
  const [selectedMetricOptions, setSelectedMetricOptions] = useState(
    activeTab === "Bias" ? [networkOptions[0]] : []
  );
  const [subTabSelection, setSubTabSelecton] = useState("LTCP");
  const [percentOrPallets, setPercentOrPallets] = useState("%");
  const [selectedNetwork, setSeletedNetwork] = useState("AMBIENT");
  const [selectedDcOptions, setSelectedDcOptions] = useState([]);
  const [isNetworkChanged, setIsNetworkChaged] = useState(false);
  const [isTabChanged, setIsTabChanged] = useState(false);
  const [lastSelectedDate, setLastSelectedDate] = useState([]);
 
  const radioOptions = () => {
    const optionsMap = {
      "ST Utilization": ["DC", "Network"],
      "LT Utilization": ["DC", "Network"],
      "LT Capacity Breach": [],
      "ST Capacity Breach": [],
      Bias: ["Outbound", "Inbound", "Customer Order", "Closing Stock"],
      Throughput: ["Inbound", "Outbound"],
    };
 
    return optionsMap[activeTab] || [];
  };
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions()[0]
  );
 
  const getGraphData = (params) => {
    setGraphData([]);
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          if (activeTab === "LT Capacity Breach") {
            if (entityNameLT) {
              setExpansionGraphDataLT([...data?.data]);
            } else {
              setGraphDataLT([...data?.data]);
            }
          } else if (activeTab === "ST Capacity Breach") {
            if (entityNameST) {
              setExpansionGraphDataST([...data?.data]);
            } else {
              setGraphDataST([...data?.data]);
            }
          } else {
            setGraphData([...data?.data]);
          }
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        setLoading(false);
        setEntityAndThreshold([]);
        setUpdateThreshold(false);
      });
  };
 
  const memoizedParams = useMemo(() => {
    let params = {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis:
        activeTab === "Bias"
          ? metricName
          : activeTab === "Throughput"
          ? percentOrPallets
          : selectedRadioValue,
      Week_count: duration,
      start_Date: new Date(startDate).toLocaleDateString("en-CA"),
      //start_Date: "2024-12-01",
      end_Date: new Date(endDate).toLocaleDateString("en-CA"),
      //end_Date: "2025-06-01",
      Level: role,
      filter: {
        RecommendedDC:
          activeTab === "Bias"
            ? metricName === "DC"
              ? selectedMetricOptions?.map((data) => data?.value)
              : []
            : ["ST Utilization", "LT Utilization", "Throughput"]?.includes(
                activeTab
              )
            ? selectedDcOptions?.map((data) => data?.value)
            : DC,
        Network:
          activeTab === "Bias"
            ? metricName === "Network"
              ? selectedMetricOptions?.map((data) => data?.value)
              : []
            : ["ST Utilization", "LT Utilization", "Throughput"]?.includes(
                activeTab
              )
            ? [selectedNetwork]
            : Network,
        startDate: dateRangeCP?.[0],
        endDate: dateRangeCP?.[1],
      },
    };
    if (updateThreshold) {
      params.user_threshold = entityAndThreshold;
    }
    if (entityNameLT) {
      params.flag = true;
      params.Entity_name = entityNameLT;
    }
    if (entityNameST) {
      params.flag = true;
      params.Entity_name = entityNameST;
    }
    if (activeTab === "Bias") {
      if (selectedRadioValue === "Outbound") {
        params.KPI = "DC to DC Outbounds";
      } else if (selectedRadioValue === "Inbound") {
        params.KPI = "DC Inbounds";
      } else if (selectedRadioValue === "Customer Order") {
        params.KPI = "DC to Customer Outbounds";
      } else {
        params.KPI = selectedRadioValue;
      }
    }
    if (activeTab === "Throughput") {
      params.subType = subTabSelection;
      if (selectedRadioValue === "Inbound") {
        params.KPI = "Inbounds";
      } else if (selectedRadioValue === "Outbound") {
        params.KPI = "Outbounds";
      }
    }
    return params;
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    dateRangeCP,
    duration,
    updateThreshold,
    entityNameLT,
    entityNameST,
    metricName,
    percentOrPallets,
    subTabSelection,
    selectedMetricOptions,
    selectedDcOptions,
  ]);
 
  const getMapedDCData = (params) => {
    GraphService.getMapedDC(params, instance)
      .then((data) => {
        if (data?.data) {
          const dcData = data?.data?.map((item) => ({
            entity: "DC",
            value: item?.LocationId,
          }));
          setMetricOptions([...dcData]);
          if (activeTab === "Bias") {
            setSelectedMetricOptions([dcData[0]]);
          }
        }
      })
      .catch((error) => console.error("Error:", error));
  };
 
  useEffect(() => {
    if (
      activeTab === "ST Utilization" ||
      activeTab === "LT Utilization" ||
      activeTab === "Throughput"
    ) {
      const storedData = JSON.parse(localStorage.getItem(activeTab));
      if (
        storedData?.network &&
        storedData?.dcOptions?.length > 0 &&
        storedData?.dcOptions[0]
      ) {
        setSeletedNetwork(storedData?.network);
        setSelectedDcOptions(storedData?.dcOptions);
      } else if (isNetworkChanged) {
        setSelectedDcOptions([metricOptions[0]]);
      }
      setIsNetworkChaged(false);
      setIsTabChanged(false);
    }
  }, [metricOptions]);
 
  useEffect(() => {
    if (activeTab === "Bias") {
      if (metricName === "DC") {
        const params = {
          Network: allData.filter.Network,
        };
        getMapedDCData(params);
      } else {
        if (allData.filter.Network.length > 0) {
          let data = [];
 
          allData?.filter?.Network?.forEach((item) => {
            data.push({ entity: "Network", value: item });
          });
          setSelectedMetricOptions([...data]);
        } else {
          setSelectedMetricOptions([networkOptions[0]]);
        }
        setMetricOptions([...networkOptions]);
      }
    } else {
      const params = {
        Network: ["AMBIENT"],
      };
      getMapedDCData(params);
    }
  }, [activeTab, metricName]);
 
  useEffect(() => {
    if (
      activeTab === "ST Utilization" ||
      activeTab === "LT Utilization" ||
      activeTab === "Throughput"
    ) {
      if (!isTabChanged) {
        setIsNetworkChaged(true);
      }
      const params = {
        Network: [selectedNetwork],
      };
      getMapedDCData(params);
 
      let tempData = {
        network: selectedNetwork,
        dcOptions: [],
      };
      localStorage.setItem(activeTab, JSON.stringify(tempData));
    }
  }, [selectedNetwork]);
 
  useEffect(() => {
    if (
      activeTab === "ST Utilization" ||
      activeTab === "LT Utilization" ||
      activeTab === "Throughput"
    ) {
      let tempData = {
        network: selectedNetwork,
        dcOptions: selectedDcOptions,
      };
      localStorage.setItem(activeTab, JSON.stringify(tempData));
    }
  }, [selectedDcOptions]);
 
  useEffect(() => {
    if (
      activeTab === "ST Utilization" ||
      activeTab === "LT Utilization" ||
      activeTab === "Throughput"
    ) {
      const storedData = JSON.parse(localStorage.getItem(activeTab));
      if (storedData?.network && storedData?.dcOptions?.length > 0) {
        //setSeletedNetwork(storedData?.network);
        //setSelectedMetricOptions(storedData?.dcOptions);
      } else {
        const params = {
          Network: ["AMBIENT"],
        };
        getMapedDCData(params);
      }
    }
  }, []);
 
  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);
 
  useEffect(() => {
    const today = dayjs(); // Get today's date as a Dayjs object
    setStartDate(today);
 
    const nextMonth = today.add(1, "month"); // Add one month to today's date
    setEndDate(nextMonth);
  }, []);
 
  useEffect(() => {
    setCurrentTabCP(activeTab);
  }, [activeTab]);
 
  useEffect(() => {
    if (activeTab === "Bias") {
      if (allData.filter.Network.length > 0) {
        let data = [];
 
        allData?.filter.Network?.forEach((item) => {
          data.push({ entity: "Network", value: item });
        });
        setSelectedMetricOptions([...data]);
      }
    }
  }, []);
 
  const calculateFourWeeksAgoDate = (date) => {
    const fourWeeksAgo = new Date(date);
    fourWeeksAgo.setDate(fourWeeksAgo.getDate() - 28);
    return fourWeeksAgo.toISOString().slice(0, 10);
  };
 
  useEffect(() => {
    if (activeTab === "Bias") {
      setLastSelectedDate(dateRangeCP);
      const startDate = calculateFourWeeksAgoDate(new Date());
      const endDate = new Date().toISOString().slice(0, 10);
      DateRangeFilterCPActions([startDate, endDate]);
    } else {
      if (lastSelectedDate?.length > 0) {
        DateRangeFilterCPActions(lastSelectedDate);
      }
    }
  }, [activeTab]);
 
  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue(
      newValue === 4 ? "Outbound" : newValue === 5 ? "Inbound" : "Network"
    );
    setTopOrBottomValue("Top");
    setCountValue("5");
    setSeletedNetwork("AMBIENT");
    setSelectedMetricOptions([]);
 
    if (
      activeTab === "ST Utilization" ||
      activeTab === "LT Utilization" ||
      activeTab === "Throughput"
    ) {
      updateDataOnTabChange(newValue);
      setIsTabChanged(true);
      setIsNetworkChaged(false);
    }
  };
 
  const updateDataOnTabChange = (newValue) => {
    const newTab = graphViewTabList?.filter(
      (item) => item?.index === newValue
    )[0]?.name;
    const storedData = JSON.parse(localStorage.getItem(newTab));
    if (storedData?.network && storedData?.dcOptions?.length > 0) {
      setSeletedNetwork(storedData?.network);
      setSelectedDcOptions(storedData?.dcOptions);
    } else {
      setSelectedDcOptions([metricOptions[0]]);
    }
  };
 
  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };
 
  const handleDurationChange = (event) => {
    setDuration(event.target.value);
  };
 
  const handleMetricNameChange = (event) => {
    setMetricName(event.target.value);
  };
 
  const handleSelectedNetwork = (event) => {
    setSeletedNetwork(event.target.value);
  };
 
  const handleSubTabSelection = (event) => {
    setSubTabSelecton(event.target.value);
  };
 
  const handlePercentageOrPallets = (event) => {
    setPercentOrPallets(event.target.value);
  };
 
  const renderChart = () => {
    const chartProps = {
      graphData,
      chartData,
      categoryList,
      showAnnotation: true,
    };
    if (activeTab === "LT Capacity Breach") {
      return (
        <TableWithChart
          activeTab={activeTab}
          graphData={
            entityNameLT ? [graphDataLT[currentRowIndex]] : graphDataLT || []
          }
          expansionGraphData={expansionGraphDataLT}
          showGraph={showGraph}
          setShowGraph={setShowGraph}
          entityAndThreshold={entityAndThreshold}
          setEntityAndThreshold={setEntityAndThreshold}
          updateThreshold={updateThreshold}
          setUpdateThreshold={setUpdateThreshold}
          entityName={entityNameLT}
          setEntityName={setEntityNameLT}
          currentRowIndex={currentRowIndex}
          setCurrentRowIndex={setCurrentRowIndex}
        />
      );
    } else if (activeTab === "ST Capacity Breach") {
      return (
        <TableWithChart
          activeTab={activeTab}
          graphData={
            entityNameST ? [graphDataST[currentRowIndex]] : graphDataST || []
          }
          expansionGraphData={expansionGraphDataST}
          showGraph={showGraph}
          setShowGraph={setShowGraph}
          entityAndThreshold={entityAndThreshold}
          setEntityAndThreshold={setEntityAndThreshold}
          updateThreshold={updateThreshold}
          setUpdateThreshold={setUpdateThreshold}
          entityName={entityNameST}
          setEntityName={setEntityNameST}
          currentRowIndex={currentRowIndex}
          setCurrentRowIndex={setCurrentRowIndex}
        />
      );
    } else if (activeTab === "Bias") {
      return (
        <AccuracyChart
          graphData={graphData}
          showAnnotation={false}
          activeTab={activeTab}
        />
      );
    } else {
      return (
        <BarChart
          {...chartProps}
          yAxisTitle={
            activeTab === "ST Utilization" ||
            (activeTab === "Throughput" && percentOrPallets === "%")
              ? "Utilization"
              : activeTab === "Throughput" && percentOrPallets === "Pallets"
              ? "Pallets"
              : "Fulfillment"
          }
          showAnnotation={false}
          activeTab={activeTab}
          type={
            activeTab === "Throughput" ? percentOrPallets : selectedRadioValue
          }
        />
      );
    }
  };
 
  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "40px",
                      rowGap: "10px",
                    }}
                  >
                    {(activeTab === "LT Capacity Breach" ||
                      activeTab === "ST Capacity Breach") && (
                      <div style={{ display: "block" }}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#aaaaaaff",
                            mb: "4px",
                            marginLeft: "18px",
                          }}
                        >
                          Duration
                        </Typography>
                        <Select
                          value={duration}
                          onChange={handleDurationChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                              {item}{" "}
                              {activeTab === "ST Capacity Breach"
                                ? "Days"
                                : "Weeks"}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    )}
 
                    {(activeTab === "ST Utilization" ||
                      activeTab === "LT Utilization" ||
                      activeTab === "Throughput") && (
                      <div style={{ display: "flex" }}>
                        <div style={{ alignSelf: "flex-end" }}>
                          <Select
                            value={selectedNetwork}
                            onChange={handleSelectedNetwork}
                            className={classes.select}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            sx={{ ...classes.select }}
                          >
                            {networkOptions?.map((option) => {
                              return (
                                <MenuItem value={option?.value}>
                                  {option?.value}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </div>
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                            }}
                          >
                            Select DC
                          </Typography>
                          <AutoCompleteSearchField
                            initialValue={metricOptions[0]}
                            selectedMetricOptions={selectedDcOptions}
                            setSelectedMetricOptions={setSelectedDcOptions}
                            metricOptions={metricOptions}
                            style={{ width: "230px" }}
                          />
                        </div>
                      </div>
                    )}
 
                    {activeTab === "Bias" && (
                      <div style={{ display: "flex" }}>
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                              marginLeft: "18px",
                            }}
                          >
                            By
                          </Typography>
                          <Select
                            value={metricName}
                            onChange={handleMetricNameChange}
                            className={classes.select}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            sx={{ ...classes.select }}
                          >
                            <MenuItem value={"Network"}>Network</MenuItem>
                            <MenuItem value={"DC"}>DC</MenuItem>
                          </Select>
                        </div>
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                            }}
                          >
                            {metricName === "Network"
                              ? "Select Network"
                              : "Select DC"}
                          </Typography>
                          <AutoCompleteSearchField
                            selectedMetricOptions={selectedMetricOptions}
                            setSelectedMetricOptions={setSelectedMetricOptions}
                            metricOptions={metricOptions}
                            placeholderName={
                              metricName === "Network"
                                ? "Select Network"
                                : "Select DC"
                            }
                               style={{ width: "230px" }}
                          />
                        </div>
                      </div>
                    )}
 
                    <div style={{ marginRight: "-15px",marginTop:"20px" }}>
                      {activeTab === "Throughput" && (
                        <div style={{ display: "flex" }}>
                          <div>
                            <Select
                              value={subTabSelection}
                              onChange={handleSubTabSelection}
                              className={classes.select}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={classes.select}
                            >
                              <MenuItem value={"LTCP"}>LTCP</MenuItem>
                              <MenuItem value={"STCP"}>STCP</MenuItem>
                            </Select>
                          </div>
                          <div>
                            <Select
                              value={percentOrPallets}
                              onChange={handlePercentageOrPallets}
                              className={classes.select}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={classes.select}
                            >
                              <MenuItem value={"%"}>%</MenuItem>
                              <MenuItem value={"Pallets"}>Pallets</MenuItem>
                            </Select>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignSelf: "center",
                      marginLeft: "50px",
                      marginTop:"10px"
                    }}
                  >
                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={selectedRadioValue === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              selectedRadioValue ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};
 
GraphViewCapacityPlanning.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};
 
const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  dateRangeCP: state.filter.dateRangeCP,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});
 
const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  DateRangeFilterCPActions: (newValue) =>
    dispatch({ type: "CP_DATERANGE", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});
 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GraphViewCapacityPlanning);